
import WProductImage from '~/components/global/w-product-image/w-product-image.vue'
import { getQueryStringForFilters } from '~/utils/get-querystring-for-filters'
import { RANGE_EXPRESSION_SEPARATOR } from '~/utils/query-params'
import WPropItem from '../w-prop-list/w-prop-item.vue'
import WPropList from '../w-prop-list/w-prop-list.vue'
import WStack from '../w-stack/w-stack.vue'

export default {
  components: {
    WStack,
    WPropList,
    WPropItem,
    WProductImage,
  },
  props: {
    facts: {
      type: Array,
      required: true,
      validator(value) {
        return value.every((item) => !!item.name)
      },
    },
    imageUrl: {
      type: String,
      required: false,
      default: null,
    },
    additionalNotes: {
      type: String,
      required: false,
      default: '',
    },
    baseRoute: {
      type: String,
      required: false,
      default: '/search',
    },
    withHyperLinks: {
      type: Boolean,
      required: false,
      default: false,
    },
    span: {
      type: Number,
      default: 1,
    },
    itemType: {
      type: String,
      default: 'Bottle',
    },
    producerCaskLogo: {
      type: String,
      required: false,
      default: null,
    },
  },

  computed: {
    nonEmptyFacts() {
      return this.facts.filter((fact) => fact.value != null)
    },
    image() {
      const { itemType, imageUrl, producerCaskLogo } = this
      const itemIsBottle = this.$isBottle({ itemType })

      return itemIsBottle ? imageUrl : producerCaskLogo
    },
  },

  methods: {
    createLink(item) {
      const { filter, value, hasRange, rawValue } = item

      // defaults
      const params = {
        ItemTypeName: this.itemType,
      }

      if (hasRange) {
        params[`${filter}${RANGE_EXPRESSION_SEPARATOR}min`] = rawValue || value
        params[`${filter}${RANGE_EXPRESSION_SEPARATOR}max`] = rawValue || value
      } else {
        params[filter] = rawValue || value
      }

      const queryString = getQueryStringForFilters(params)

      return `${this.baseRoute}?${queryString}`
    },
  },
}
